/* @flow strict */

import * as React from 'react';
import CollapsedPanel from '/client/src/components/panel/collapsedPanel';
import TagsInput from 'react-tagsinput';
import { emailRegexp } from '/client/src/constants';

type PropsType = {
  purchasedNotificationEmails: string,
  soldOutNotificationEmails: string,
  isSetNotificationEmail: boolean,
  handleChangeInput: () => void,
  handleControlNotificationEmail: () => void
};

const EmailNotify = ({
  isSetNotificationEmail,
  purchasedNotificationEmails,
  soldOutNotificationEmails,
  handleChangeInput,
  handleControlNotificationEmail
}: PropsType): React.Element<typeof React.Element> => {
  const [tags, setTags] = React.useState(_.size(purchasedNotificationEmails) ?
    _.split(purchasedNotificationEmails, ',') :
    []);
  const [tags2, setTags2] = React.useState(_.size(soldOutNotificationEmails) ?
    _.split(soldOutNotificationEmails, ',') :
    []);

  const handleChange = (_tags: []) => {
     if (_.size(_tags) < 10) {
      setTags(_tags);

      handleChangeInput({
        target: {
          name: 'purchased_notification_emails',
          value: _tags.join()
        }
      });
    }
  };

  const handleChange2 = (_tags2: []) => {
    if (_.size(_tags2) < 10) {
      setTags2(_tags2);

      handleChangeInput({
        target: {
          name: 'sold_out_notification_emails',
          value: _tags2.join()
        }
      });
    }
  };

  return (
    <CollapsedPanel
      status={isSetNotificationEmail}
      title='Receive email notifications'
      onChange={(status: boolean): any => handleControlNotificationEmail(status)}
    >
      <>
        <label htmlFor="">Send a notification when a ticket is purchased to the email below</label>
        <TagsInput
          value={tags}
          onChange={handleChange}
          addOnBlur
          addOnPaste
          addKeys={[9, 13, 32, 188]}
          inputProps={{
            placeholder: ''
          }}
          onlyUnique
          validationRegex={emailRegexp}
          className={'react-tagsinput email-notify-tags'}
        />

        <br/>

        <label htmlFor="">Send a notification when the event is sold out to the email below</label>
        <TagsInput
          value={tags2}
          onChange={handleChange2}
          addOnBlur
          addOnPaste
          addKeys={[9, 13, 32, 188]}
          inputProps={{
            placeholder: ''
          }}
          onlyUnique
          validationRegex={emailRegexp}
          className={'react-tagsinput email-notify-tags'}
        />
      </>
    </CollapsedPanel>
  );
};

export default EmailNotify;
